import { NgForOf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { VaFullscreenLightboxService } from '../lightbox/fullscreen-lightbox.service';

@Component({
  selector: 'va-image-gallery',
  styleUrls: ['./image-gallery.component.scss'],
  template: `
    <div>
      <div class="va-image-gallery">
        <div class="va-image-gallery-container" *ngFor="let imageUrl of imageUrls; let i = index" (click)="onClick(i)">
          <div class="va-image-gallery-aspect-ratio">
            <img
              class="va-image-gallery-fix-position va-image-gallery-img"
              [src]="imageUrl"
              [srcset]="getSrcsetImageUrls(imageUrl)"
              style="cursor: pointer;"
            />
          </div>
        </div>
      </div>
    </div>
  `,
  standalone: true,
  imports: [NgForOf],
  providers: [VaFullscreenLightboxService],
})
export class VaImageGalleryComponent {
  @Input() imageUrls: string[];
  @Input() clickable = true;

  constructor(private lightbox: VaFullscreenLightboxService) {}

  getSrcsetImageUrls(imageUrl: string): string {
    return `${imageUrl}=s640 640w, ${imageUrl}=s1280 1280w, ${imageUrl}=s1920 1920w`;
  }

  onClick(index: number): void {
    if (this.clickable) {
      this.lightbox.open({ imageUrls: this.imageUrls, index: index });
    }
  }
}
